<form [formGroup]="updateAppearanceForm">
    <div class="appearance-container">
        <!-- <mat-form-field appearance="outline" class="example-full-width" style="margin-right: 20px;">
                <input matInput placeholder="Ex. Wiky Solutions" formControlName="text">
            </mat-form-field> -->

        <app-file-upload (fileChanged)="onFileChange($event)" [imageUrl]="updateAppearanceForm.value.logo"
            [acceptedFiles]="'image/*'"></app-file-upload>

        <section class="button-section">
            <button mat-raised-button color="primary" (click)="saveChanges()" [disabled]="loading">{{ 'UPDATE' |
                translate}}</button>
            <div *ngIf="loading" class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </section>
    </div>
</form>